import styled from 'styled-components';

const LiBase = styled.li`
  display: inline-block;
  position: relative;

  &:not(:last-child) {
    margin-right: 18px;
  }

  &:not(:last-child)::after {
    margin-right: 12px;
    position: absolute;
    top: 10px;
    right: -22px;
    display: inline-block;
    content: '';
    height: 3px;
    width: 3px;
    border-radius: 50px;
  }
`;

const Li = styled(LiBase)`
  &:not(:last-child)::after {
    background: ${({ theme }) =>
      theme.pointCard.colors.backgroundSortInfoDivider};
  }
`;

export const S = {
  Container: styled.div`
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between; // <- this spreads items
    border-bottom: 1px solid
      ${({ theme }) => theme.pointCard.colors.backgroundContainer};
    cursor: pointer;
  `,
  RouteInfo: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: calc(100% - 84px);
    flex: 1;
  `,
  Title: styled.div`
    font-weight: bold;
    white-space: normal;
    word-break: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 3;       // limit to 3 lines
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    max-height: 4.8em;           // ~3 lines × 1.6em line-height (adjust if needed)
  `,
  ShortInfo: styled.ul`
    margin: 0;
    padding: 0;
    color: #777; // light gray text
  `,
  LiBase,
  Li,
  Location: styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};
